"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genBtcJumpCkbVirtualTx = void 0;
const base_1 = require("@ckb-lumos/base");
const error_1 = require("../error");
const utils_1 = require("../utils");
const rgbpp_1 = require("../utils/rgbpp");
const constants_1 = require("../constants");
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
/**
 * Generate the virtual ckb transaction for the jumping tx from BTC to CKB
 * @param collector The collector that collects CKB live cells and transactions
 * @param xudtTypeBytes The serialized hex string of the XUDT type script
 * @param rgbppLockArgsList The rgbpp assets cell lock script args array whose data structure is: out_index | bitcoin_tx_id
 * @param transferAmount The XUDT amount to be transferred
 * @param witnessLockPlaceholderSize The WitnessArgs.lock placeholder bytes array size and the default value is 3000(It can make most scenarios work properly)
 * @param ckbFeeRate The CKB transaction fee rate, default value is 1100
 * @param isMainnet
 */
const genBtcJumpCkbVirtualTx = (_a) => __awaiter(void 0, [_a], void 0, function* ({ collector, xudtTypeBytes, rgbppLockArgsList, transferAmount, toCkbAddress, witnessLockPlaceholderSize, ckbFeeRate, }) {
    var _b, e_1, _c, _d;
    const isMainnet = toCkbAddress.startsWith('ckb');
    const xudtType = base_1.blockchain.Script.unpack(xudtTypeBytes);
    if (!(0, utils_1.isTypeAssetSupported)(xudtType, isMainnet)) {
        throw new error_1.TypeAssetNotSupportedError('The type script asset is not supported now');
    }
    const rgbppLocks = rgbppLockArgsList.map((args) => (0, rgbpp_1.genRgbppLockScript)(args, isMainnet));
    let rgbppCells = [];
    try {
        for (var _e = true, rgbppLocks_1 = __asyncValues(rgbppLocks), rgbppLocks_1_1; rgbppLocks_1_1 = yield rgbppLocks_1.next(), _b = rgbppLocks_1_1.done, !_b; _e = true) {
            _d = rgbppLocks_1_1.value;
            _e = false;
            const rgbppLock = _d;
            const cells = yield collector.getCells({ lock: rgbppLock, type: xudtType });
            if (!cells || cells.length === 0) {
                throw new error_1.NoRgbppLiveCellError('No rgbpp cells found with the xudt type script and the rgbpp lock args');
            }
            rgbppCells = [...rgbppCells, ...cells];
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (!_e && !_b && (_c = rgbppLocks_1.return)) yield _c.call(rgbppLocks_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    rgbppCells = rgbppCells.sort(rgbpp_1.compareInputs);
    const { inputs, sumInputsCapacity, sumAmount } = collector.collectUdtInputs({
        liveCells: rgbppCells,
        needAmount: transferAmount,
        isMax: true,
    });
    const rpbppCellCapacity = (0, utils_1.calculateRgbppCellCapacity)(xudtType);
    const outputsData = [(0, utils_1.append0x)((0, utils_1.u128ToLe)(transferAmount))];
    const toLock = (0, ckb_sdk_utils_1.addressToScript)(toCkbAddress);
    if ((0, utils_1.isLockArgsSizeExceeded)(toLock.args)) {
        throw new Error('The lock script size of the to ckb address is too large');
    }
    let changeCapacity = sumInputsCapacity;
    const outputs = [
        {
            lock: (0, rgbpp_1.genBtcTimeLockScript)(toLock, isMainnet),
            type: xudtType,
            capacity: (0, utils_1.append0x)(rpbppCellCapacity.toString(16)),
        },
    ];
    if (sumAmount > transferAmount) {
        outputs.push({
            // The Vouts[0] for OP_RETURN and Vouts[1] for RGBPP assets, BTC time cells don't need btc tx out_index
            lock: (0, rgbpp_1.genRgbppLockScript)((0, rgbpp_1.buildPreLockArgs)(1), isMainnet),
            type: xudtType,
            capacity: (0, utils_1.append0x)(rpbppCellCapacity.toString(16)),
        });
        outputsData.push((0, utils_1.append0x)((0, utils_1.u128ToLe)(sumAmount - transferAmount)));
        changeCapacity -= rpbppCellCapacity;
    }
    const cellDeps = [(0, constants_1.getRgbppLockDep)(isMainnet), (0, constants_1.getXudtDep)(isMainnet), (0, constants_1.getRgbppLockConfigDep)(isMainnet)];
    const needPaymasterCell = inputs.length < outputs.length;
    if (needPaymasterCell) {
        cellDeps.push((0, constants_1.getSecp256k1CellDep)(isMainnet));
    }
    const witnesses = [];
    const lockArgsSet = new Set();
    for (const cell of rgbppCells) {
        if (lockArgsSet.has(cell.output.lock.args)) {
            witnesses.push('0x');
        }
        else {
            lockArgsSet.add(cell.output.lock.args);
            witnesses.push(constants_1.RGBPP_WITNESS_PLACEHOLDER);
        }
    }
    const ckbRawTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData,
        witnesses,
    };
    if (!needPaymasterCell) {
        const txSize = (0, ckb_sdk_utils_1.getTransactionSize)(ckbRawTx) + (witnessLockPlaceholderSize !== null && witnessLockPlaceholderSize !== void 0 ? witnessLockPlaceholderSize : (0, rgbpp_1.estimateWitnessSize)(rgbppLockArgsList));
        const estimatedTxFee = (0, utils_1.calculateTransactionFee)(txSize, ckbFeeRate);
        changeCapacity -= estimatedTxFee;
        ckbRawTx.outputs[ckbRawTx.outputs.length - 1].capacity = (0, utils_1.append0x)(changeCapacity.toString(16));
    }
    const virtualTx = Object.assign({}, ckbRawTx);
    const commitment = (0, rgbpp_1.calculateCommitment)(virtualTx);
    return {
        ckbRawTx,
        commitment,
        needPaymasterCell,
        sumInputsCapacity: (0, utils_1.append0x)(sumInputsCapacity.toString(16)),
    };
});
exports.genBtcJumpCkbVirtualTx = genBtcJumpCkbVirtualTx;
